import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { RootState } from 'store'

export function capitaliseFirstLetter(string: string) {
  // capitalise the first letter of each word in a string
  let temp = string.toLowerCase()
  temp = temp
    .split(' ')
    .map(word => {
      return word.charAt(0).toUpperCase() + word.slice(1)
    })
    .join(' ')
  return temp
}
